import {
  CardNumberElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';

import useCreateSetupIntent from 'hooks/useCreateSetupIntent';

const useCreateSetupIntentAndStripeSetupIntent = (usePublicApi) => {
  const elements = useElements();
  const stripe = useStripe();

  const [createSetupIntent] = useCreateSetupIntent(usePublicApi);

  const getCreateSetupIntentData = async (variables) =>
    await createSetupIntent({
      skip: !variables,
      variables,
    });

  const getStripeSetupIntent = async (
    setupIntentClientSecret,
    fullName,
    postalCode,
    email
  ) => {
    if (!setupIntentClientSecret) {
      return;
    }

    // Get a reference to a mounted CardNumberElement. Elements knows how
    // to find your CardNumberElement because there can only ever be one of
    // each type of element.
    const card = elements.getElement(CardNumberElement);

    // Use your card number Element with other Stripe.js APIs
    return await stripe.confirmCardSetup(setupIntentClientSecret, {
      payment_method: {
        card,
        billing_details: {
          address: { postal_code: postalCode },
          email,
          name: fullName,
        },
      },
    });
  };

  const handleStripeAndSetupIntent = async ({
    businessName,
    email,
    firstName,
    lastName,
    phone,
    postalCode,
  } = {}) => {
    const name = `${firstName || ''} ${lastName || ''}`;
    const { data: setUpIntentData, errors: createSetupIntentError } =
      await getCreateSetupIntentData({
        businessName,
        email,
        firstName,
        lastName,
        phone,
        postalCode,
        ...(!usePublicApi && { name }),
      });
    const { error: stripeError, setupIntent: stripeSetUpIntent } =
      await getStripeSetupIntent(
        setUpIntentData?.createSetupIntent?.clientSecret,
        name,
        postalCode,
        email
      );

    return {
      createSetupIntentError,
      setUpIntentData,
      stripeSetUpIntent,
      stripeError,
    };
  };

  return {
    getCreateSetupIntentData,
    getStripeSetupIntent,
    handleStripeAndSetupIntent,
    stripeNotLoaded: !stripe || !elements,
  };
};

export default useCreateSetupIntentAndStripeSetupIntent;
